import React from 'react'
import Img from 'gatsby-image'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import { fragPost } from '../../utils/fragments'
import { mapPost, mapMetaData } from '../../utils/mapper'

import MetaData from '../../components/metadata'
import Poster from '../../components/poster'
import Lead from '../../components/lead'
import Quote from '../../components/quote'
import Section from '../../components/section'
import VideoSlice from '../../components/video/slice'
import EndPiece from '../../components/endpiece'
import Footer from '../../components/footer'
import Feedback from '../../components/feedback'

import { CONTENTTYPES } from '../../utils/constants'

import styles from '../../styles/site'

const Post = props => {
  const { classes } = props
  const metadata = mapMetaData(props.data.post)
  const post = mapPost(props.data.post)

  return (
    <div>
      <MetaData data={metadata} />
      <Poster image={post.image} urls={post.video_bg.urls} poster={post.video_bg.poster} />
      <div className={classes.mainFloat}>
        <Lead
          title={post.title}
          author={post.author}
          published={post.published}
          lead={post.lead}
          path={props.location.pathname}
          tags={post.tags}
        />
        {post.contents &&
          post.contents.map((content, index) => {
            switch (content.type) {
              case CONTENTTYPES.section:
                return <Section key={index} section={content} />
              case CONTENTTYPES.quote:
                return <Quote key={index} quote={content} />
              case CONTENTTYPES.video:
                return <VideoSlice key={index} video={content} />
            }
          })}
        <EndPiece author={post.author} published={post.published} />
        <Feedback post={post}/>
      </div>
      <Footer policies={props.data.policies.edges}/>
    </div>
  )
}

export default withStyles(styles)(Post)

export const query = graphql`
  query postQuery($id: String!) {
    post: prismicCtBlog(id: { eq: $id }) {
      ...post
    }

    policies: allPrismicCtDoc {
      edges {
      node {
        uid
        data {
            title {
              
              text
            }
            
            
          }
      }
      }
      }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog/post.js